import React from 'react';

import { List, Typography } from 'antd';
import { Trans } from 'react-i18next';

import { DateSince } from 'common-ui';
import { UserNotification } from 'core/lib';
import { MODULE_NAMES } from 'core/lib/constants';
import colors from 'core/lib/theme/colors';

import { NotificationCardModuleUpdateIcon, NotificationCardWrapper } from '../components';

const { Text } = Typography;

type ModuleUpdateNotificationCardProps = {
  notification: UserNotification;
  onClick: (id: number) => void;
};

const ModuleUpdateNotificationCard = ({ notification, onClick }: ModuleUpdateNotificationCardProps) => {
  const type = notification.objectType ? MODULE_NAMES[notification.objectType] : notification.type;

  return (
    <NotificationCardWrapper hasQueryParams={false} key={notification.id} notification={notification} onClick={onClick}>
      <List.Item.Meta
        avatar={<NotificationCardModuleUpdateIcon />}
        title={
          <Trans
            i18nKey="notifications:module.update"
            shouldUnescape={true}
            values={{ type, objectName: notification.objectName }}
            components={{ linkText: <Text style={{ color: colors.Primary.rgba }}></Text> }}
          />
        }
        description={<DateSince date={notification.dateCreated} />}
      />
    </NotificationCardWrapper>
  );
};

export default ModuleUpdateNotificationCard;
